if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Parse car configuration from URL hash and populate hidden fields
        // Use setTimeout to ensure DOM is ready
        setTimeout(() => this.populateCarConfiguration(), 100);

        // Also try immediately
        this.populateCarConfiguration();
      }

      populateCarConfiguration() {
        // Get the URL hash
        const hash = window.location.hash.slice(1);
        if (!hash) {
          console.log('⚠️ No hash found, skipping car configuration');
          return;
        }

        // Split by / to get the parts
        const parts = hash.split('/');

        if (parts.length >= 1) {
          const manufacturer = this.urlToDisplay(parts[0]);
          const model = parts[1] ? this.urlToDisplay(parts[1]) : '';
          const motor = parts[2] ? this.urlToDisplay(parts[2]) : '';

          console.log('🚗 Parsed config:', { manufacturer, model, motor });

          // Set individual fields - use name attribute, not ID!
          // Use this.form which was already set in constructor
          const manufacturerField = this.form ? this.form.querySelector('[name="properties[Hersteller]"]') : null;
          const modelField = this.form ? this.form.querySelector('[name="properties[Modell]"]') : null;
          const motorField = this.form ? this.form.querySelector('[name="properties[Motor]"]') : null;
          const fullConfigField = this.form ? this.form.querySelector('[name="properties[Fahrzeugkonfiguration]"]') : null;

          console.log('🚗 Fields found:', {
            manufacturerField: !!manufacturerField,
            modelField: !!modelField,
            motorField: !!motorField,
            fullConfigField: !!fullConfigField
          });

          if (manufacturerField) manufacturerField.value = manufacturer;
          if (modelField) modelField.value = model;
          if (motorField) motorField.value = motor;

          // Create full configuration string
          if (fullConfigField && manufacturer) {
            let fullConfig = manufacturer;
            if (model) fullConfig += ` / ${model}`;
            if (motor) fullConfig += ` / ${motor}`;
            fullConfigField.value = fullConfig;
            console.log('✅ Car configuration populated:', fullConfig);
          }
        }
      }

      urlToDisplay(encoded) {
        if (!encoded) return '';

        let result = encoded;

        try {
          // First decode any URL encoding
          result = decodeURIComponent(result);
        } catch (error) {
          console.error('Error decoding URL string:', error);
        }

        // Handle the special case of dashes in parentheses
        result = result.replace(/\(~~\)/g, '(--)');
        result = result.replace(/\(--\)/g, '(--)');

        // Then handle the standard replacements
        result = result
          .replace(/--/g, ', ')
          .replace(/-/g, ' ');

        // Add spaces between numbers and units
        result = result
          .replace(/(\d+)(ccm|KW|PS|kW|hp|ps)/g, '$1 $2')
          .replace(/(\d+\.\d+)(ccm|KW|PS|kW|hp|ps)/g, '$1 $2');

        return result;
      }

      saveVehicleConfigAsOrderAttribute(formData) {
        console.log('🔧 saveVehicleConfigAsOrderAttribute called');

        // Extract vehicle configuration from form data
        const manufacturer = formData.get('properties[Hersteller]');
        const model = formData.get('properties[Modell]');
        const motor = formData.get('properties[Motor]');

        console.log('🔧 Extracted from formData:', { manufacturer, model, motor });

        // Only proceed if we have vehicle configuration data
        if (!manufacturer && !model && !motor) {
          console.log('⚠️ No vehicle configuration found in formData, skipping order attribute');
          return;
        }

        // Format the vehicle configuration for packing slip
        let vehicleConfig = '';
        if (manufacturer) vehicleConfig += `Hersteller: ${manufacturer}\n`;
        if (model) vehicleConfig += `Modell: ${model}\n`;
        if (motor) vehicleConfig += `Motor: ${motor}`;

        console.log('🔧 Formatted vehicle config:', vehicleConfig);

        // Update cart attributes via Shopify Cart API
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              'Fahrzeugkonfiguration': vehicleConfig
            }
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('✅ Vehicle configuration saved as order attribute:', vehicleConfig);
          console.log('✅ Cart response:', data);
        })
        .catch(error => {
          console.error('❌ Error saving vehicle configuration as order attribute:', error);
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Try to populate car configuration one more time before submission
        this.populateCarConfiguration();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);


        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // Save vehicle configuration as Order Attributes for Packing Slip
            this.saveVehicleConfigAsOrderAttribute(formData);

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
